<template>
  <div
    class="check-table-header"
    :style="{
      '--division': division
    }"
  >
    <div v-for="i in division" :key="`check_table_header_${i}`" class="header-type-fire-fighting">
      <div class="item A"><span>{{ title }}</span></div>
      <div class="item B"><span>점검결과</span></div>
      <div class="item C"><span>적합</span></div>
      <div class="item D"><span>부적합</span></div>
      <div class="item E"><span>N/A</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckTableHeader',
  props: {
    title: String,
    division: { type: Number, default: () => { return 1 }},
  },

}
</script>

<style lang="scss" scoped>
.check-table-header {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(var(--division), 1fr);
}
.item {
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 50px;

  border-bottom: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}
.header-type-fire-fighting {
  display: grid;
  grid-template-columns: 1fr 50px 50px 50px;
  grid-template-areas:
    "A B B B"
    "A C D E";

  .A { height: 100%; grid-area: A; }
  .B { height: 100%; grid-area: B; }
  .C { height: 100%; grid-area: C; }
  .D { height: 100%; grid-area: D; }
  .E { height: 100%; grid-area: E; }
}
</style>
